import { SaveOutlined } from "@ant-design/icons";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SavedDiscordMessages from "./SavedDiscordMessages";

const { TabPane } = Tabs;

export default function DiscordMessages() {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState("saved");

  useEffect(() => {
    const tab = new URLSearchParams(location.search).get("tab");
    const existingTabs = ["saved"];
    // check if tab value obtained from query string exists
    if (typeof tab === "string" && existingTabs.includes(tab)) {
      setCurrentTab(tab);
    }
  }, [location]);

  return (
    <div>
      <Tabs
        activeKey={currentTab}
        onChange={(tab) => {
          navigate(`/messages?tab=${tab}`);
        }}
      >
        <TabPane
          tab={
            <span>
              <span className="-mt-1">
                <SaveOutlined />
              </span>
              <span className="-ml-1">Saved</span>
            </span>
          }
          key="saved"
        >
          <SavedDiscordMessages />
        </TabPane>
      </Tabs>
    </div>
  );
}
